import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { AwardApproval } from 'containers/forms/dashboard'

export default class AwardApprovalModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    isPersonalReflectionMandatory: PropTypes.bool.isRequired,
    lastPersonalReflection: PropTypes.string,
    isOver16yearsOld: PropTypes.bool.isRequired,
    isGoldLevel: PropTypes.bool.isRequired
  }

  render() {
    const {
      colorClass,
      modalId
    } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        narrow noHeader
      >
        <MaterialModal.Content noFooter noHeader>
          <AwardApproval {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
